// LiveStreamBalanceWarning.js
import { connect } from 'react-redux';

import { PRIVATE_LIVESTREAM_INSUFFICIENT_BALANCE_REMAINING_PRICE_MULTIPLIER } from '../RemoteConfigKeys.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getOperationData from '../selector/getOperationData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import addvalue from '../action/addvalue.js';

import LiveStreamBalanceWarning from '../component/LiveStreamBalanceWarning.jsx';

const mapStateToProps = (state, { streamId }) => {
  return {
    exclusivePrivateRunOutAt: getOperationData(
      state,
      ['liveStream', 'paid', streamId],
      'exclusivePrivateRunOutAt'
    ),
    remainingBalanceMultiple: getRemoteConfigData(
      state,
      PRIVATE_LIVESTREAM_INSUFFICIENT_BALANCE_REMAINING_PRICE_MULTIPLIER
    ),
    timestampOffsetSeconds: getTimestampOffset(state, Accuracy.SECOND),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addvalue: () => dispatch(addvalue({ via: 'insufficient' })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamBalanceWarning);
